import { cn } from '../../../../lib/utils';
import { Button } from '../../../ui/button';
import { ArrowLeft } from 'lucide-react';
import { PersonCircle } from 'react-bootstrap-icons';
import { useContext } from 'react';
import { LocalizeContext } from 'react-locale-language';

export default function CalculatorTabs({
  calculators = [],
  userName,
  email,
  isSidebarCollapsed,
  onCollapseIconClick,
  showRujumBoard,
  allowedCalculators = [],
  onTabChange,
  activeTab,
  apartmentProfiles,
  onAddProfileClick,
  fromCustomerPortal,
  readOnlyMode,
  showCollapseArrow = false
}) {
  const { translate, isRTL } = useContext(LocalizeContext);

  return (
    <div
      className={cn(
        'flex items-center justify-center w-[80%] content-center',
        isSidebarCollapsed ? 'w-full' : 'w-[80%]'
      )}
    >
      <div
        className={`flex max-md:flex-col items-center relative p-3.5 gap-8 shadow-sm rounded-lg w-full bg-white ${
          isRTL ? '!pl-4' : ''
        }`}
      >
        {/* Left Arrow OVERLAY */}

        <div className={`flex items-center gap-2 ${fromCustomerPortal || (readOnlyMode && !showCollapseArrow) ? 'mx-0' : 'mx-2 '}`}>
          {(!readOnlyMode || showCollapseArrow) && !fromCustomerPortal && (
            <div
              className={cn(
                'md:absolute left-0 top-0 bottom-0 rtl:right-0 rtl:left-auto rtl:rotate-180 flex items-center justify-center bg-primary p-0.5 cursor-pointer',
                'rounded-full md:rounded-l-lg md:rounded-r-none'
              )}
              onClick={onCollapseIconClick}
            >
              <ArrowLeft
                className={cn(
                  'w-4 h-4 text-white',
                  isSidebarCollapsed ? 'rotate-0 rtl:rotate-0' : 'rotate-180 rtl:rotate-180'
                )}
              />
            </div>
          )}
          <PersonCircle size={22} className="ms-2 align-text-top" />
          <div className="whitespace-nowrap">
            <p className="text-sm font-bold m-0">{userName}</p>
            <p className="text-xs font-semibold m-0">{email}</p>
          </div>
        </div>

        <div className="w-full flex items-center justify-between text-white gap-2.5 flex-wrap ">
          <div className="flex items-center gap-2.5">
            {showRujumBoard && (
              <Button
                variant={activeTab === 'rujum' ? 'default' : ''}
                className={`shadow-none rounded-lg m-0 ${
                  activeTab === 'rujum' ? '' : 'bg-primary-light text-muted-blue '
                }`}
                onClick={() => onTabChange('rujum')}
              >
                {translate('rujum')}
              </Button>
            )}
            {calculators.length > 0 &&
              calculators
                .filter(({ key }) => allowedCalculators.includes(key))
                .map(({ name, key }) => (
                  <Button
                    variant={activeTab === key ? 'default' : ''}
                    className={`shadow-none rounded-lg m-0 ${
                      activeTab === key ? '' : 'bg-primary-light text-muted-blue'
                    }`}
                    key={name}
                    onClick={() => onTabChange(key)}
                  >
                    {translate(name)}
                  </Button>
                ))}
          </div>
          {!readOnlyMode && (
            <div className="flex items-center gap-2.5">
              <Button
                variant="outline"
                className="rounded-full border-gray text-gray hover:bg-gray-200 m-0"
                onClick={() => onAddProfileClick({ mode: 'add', data: { type: 'paper-apartment' } })}
              >
                {translate('profile')}
              </Button>
              {apartmentProfiles
                // only show profiles that has status 'showToCustomer' set to true in customer portal
                .filter(profile => !fromCustomerPortal || profile?.showToCustomer)
                .map((profile, key) => (
                  <Button
                    variant="outline"
                    className="rounded-full border-gray text-gray hover:bg-gray-200 m-0 relative"
                    onClick={() => onAddProfileClick({ mode: 'update', data: profile })}
                    key={key}
                  >
                    P{key + 1}
                    {!fromCustomerPortal && profile?.isPublishedForReview && (
                      <span
                        className={cn(
                          'absolute top-1 right-3 w-2 h-2 rounded-full border border-white',
                          profile?.isApproved ? 'bg-green-500' : 'bg-yellow-500'
                        )}
                      />
                    )}
                  </Button>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
